import React from "react";
import { PostTemplate } from "./template/PostTemplate";
import { SinglePostTemplate } from "./template/SinglePostTemplate";

const AllEvents = ({ item , horizontal = false }) => {
    const data = {
        image: item.feature_img.src,
        title: item.title,
        description: item.description ?? '....',
        updated_at: item.updated_at,
        url: `/events/${item.id}` ?? '#'
    };

    return (
        <div>
            {horizontal ? <SinglePostTemplate props={data} /> : <PostTemplate props={data} />}
        </div>
    );
}

export default AllEvents;
